/* ============================================================
   Mustard Living — Trade Show Order Form JS
   File: assets/trade-order-form.js
   ============================================================ */

const PRICES = {
  lampshades: {
    Plain:    { 6: 47.40, 12: 65.40, 16: 71.40, 18: 77.40 },
    Pleated:  { 6: 53.40, 12: 71.40, 16: 77.40, 18: 83.40 }
  },
  pouches:   24.00,
  pillow:    { '16x16': 36.00, '18x18': 42.00 },
  napkins:   { Plain: 48.00, Scalloped: 60.00 },
  plainPlacemats: 96.00,
  quiltedPlacemats: 144.00,
  mittens:   48.00,
  tablecloth: { Plain: 110.77, Scalloped: 120.00 },
  lampbases: { 12: 73.85, 14: 86.15 },
  giftwrapper: null
};

const COLOUR_MAP = {
  'Ikat':        ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Stripe':      ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Block Print': ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Floral':      ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Geometric':   ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Solid':       ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Check':       ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Paisley':     ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Abstract':    ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Nature':      ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Batik':       ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Tie-Dye':     ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Damask':      ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru'],
  'Chevron':     ['Mustard','Indigo','Rust','Sage','Cream','Teal','Coral','Navy','Ochre','Dusty Rose','Forest','Terracotta','Sky','Ecru']
};

const PRODUCT_LABELS = {
  lampshades: 'Lampshades',
  pouches: 'Pouches',
  pillow: 'Pillow covers',
  napkins: 'Napkins (set of 4)',
  'plain-placemats': 'Plain placemats (set of 4)',
  'quilted-placemats': 'Quilted placemats (set of 4)',
  mittens: 'Quilted mittens (set of 2)',
  tablecloth: 'Tablecloth',
  lampbases: 'Lampbases',
  giftwrapper: 'Gift wrapper'
};

const FIXED_PRICES = {
  pouches: PRICES.pouches,
  'plain-placemats': PRICES.plainPlacemats,
  'quilted-placemats': PRICES.quiltedPlacemats,
  mittens: PRICES.mittens
};

const STORAGE_KEY = 'mustard-trade-registration:draft';
const PATTERN_COLOUR_PAIRS = [
  ['line-pattern', 'line-colour'],
  ['line-qp-pattern', 'line-qp-colour'],
  ['line-qp-pattern1', 'line-qp-colour1'],
  ['line-qp-pattern2', 'line-qp-colour2']
];

function fmt(n) {
  if (n == null) return 'TBD';
  return '$' + n.toFixed(2);
}

function populateColours(patternSelect, colourSelect) {
  const pattern = patternSelect.value;
  colourSelect.innerHTML = '';
  if (!pattern || !COLOUR_MAP[pattern]) {
    colourSelect.innerHTML = '<option value="">Select pattern first</option>';
    colourSelect.disabled = true;
    return;
  }
  colourSelect.disabled = false;
  const blank = document.createElement('option');
  blank.value = '';
  blank.textContent = 'Select colour';
  colourSelect.appendChild(blank);
  COLOUR_MAP[pattern].forEach(function(c) {
    const opt = document.createElement('option');
    opt.value = c;
    opt.textContent = c;
    colourSelect.appendChild(opt);
  });
}

function setSubtotal(id, value) {
  const el = document.getElementById('subtotal-' + id);
  if (!el) return;
  if (value == null || isNaN(value) || value <= 0) {
    el.textContent = '—';
    el.classList.remove('has-value');
  } else {
    el.textContent = fmt(value);
    el.classList.add('has-value');
  }
}

function setRowTotalDisplay(lineItem, value) {
  const el = lineItem.querySelector('.row-total-display');
  if (!el) return;
  if (value == null || isNaN(value) || value <= 0) {
    el.textContent = '—';
    el.classList.remove('has-value');
  } else {
    el.textContent = fmt(value);
    el.classList.add('has-value');
  }
}

function setLinePrice(lineItem, price) {
  const el = lineItem.querySelector('.line-price');
  if (!el) return;
  if (price == null) {
    el.textContent = el.dataset.fixedPrice || '—';
  } else {
    el.textContent = fmt(price);
  }
}

function getLineUnits(lineItem) {
  const input = lineItem.querySelector('.line-units');
  return parseInt(input && input.value) || 0;
}

function getLinePrice(productId, lineItem) {
  switch (productId) {
    case 'lampshades': {
      const style = lineItem.querySelector('.line-style');
      const size = lineItem.querySelector('.line-size');
      const s = style && style.value;
      const sz = size && parseInt(size.value);
      if (!s || !sz || !PRICES.lampshades[s]) return null;
      return PRICES.lampshades[s][sz] || null;
    }
    case 'pouches':
      return PRICES.pouches;
    case 'pillow': {
      const size = lineItem.querySelector('.line-size');
      const s = size && size.value;
      return s && PRICES.pillow[s] ? PRICES.pillow[s] : null;
    }
    case 'napkins': {
      const style = lineItem.querySelector('.line-style');
      const s = style && style.value;
      return s && PRICES.napkins[s] ? PRICES.napkins[s] : null;
    }
    case 'plain-placemats':
      return PRICES.plainPlacemats;
    case 'quilted-placemats':
      return PRICES.quiltedPlacemats;
    case 'mittens':
      return PRICES.mittens;
    case 'tablecloth': {
      const style = lineItem.querySelector('.line-style');
      const s = style && style.value;
      return s && PRICES.tablecloth[s] ? PRICES.tablecloth[s] : null;
    }
    case 'lampbases': {
      const size = lineItem.querySelector('.line-size');
      const s = size && parseInt(size.value);
      return s && PRICES.lampbases[s] ? PRICES.lampbases[s] : null;
    }
    case 'giftwrapper':
      return PRICES.giftwrapper;
    default:
      return null;
  }
}

function updateLineItem(lineItem, productId) {
  const price = getLinePrice(productId, lineItem);
  setLinePrice(lineItem, price);
  const units = getLineUnits(lineItem);
  const rowTotal = price != null && units > 0 ? price * units : 0;
  setRowTotalDisplay(lineItem, rowTotal > 0 ? rowTotal : 0);
  updateProductSubtotal(productId);
}

function updateProductSubtotal(productId) {
  const fieldsEl = document.getElementById('fields-' + productId);
  if (!fieldsEl) return;
  let sum = 0;
  fieldsEl.querySelectorAll('.trade-line-item').forEach(function(lineItem) {
    const totalEl = lineItem.querySelector('.row-total-display');
    if (totalEl && totalEl.textContent !== '—') {
      sum += parseFloat(totalEl.textContent.replace('$', '').replace(',', '')) || 0;
    }
  });
  setSubtotal(productId, sum);
  updateGrandTotal();
}

function populateQuiltedPlainPatterns(lineItem) {
  const pattern = lineItem.querySelector('.line-qp-pattern');
  if (!pattern) return;
  pattern.innerHTML = '<option value="">Select pattern</option>';
  ['Ikat','Stripe','Block Print','Floral','Geometric','Solid','Check','Paisley','Abstract','Nature'].forEach(function(p) {
    const o = document.createElement('option');
    o.value = p;
    o.textContent = p;
    pattern.appendChild(o);
  });
  pattern.disabled = false;
}

function updateQuiltedStyleRows(lineItem) {
  const style = lineItem.querySelector('.line-style');
  const plainFields = lineItem.querySelectorAll('.line-qp-plain-fields');
  const revRow = lineItem.querySelector('.line-qp-reversible-fields');
  if (!style || !revRow) return;
  const v = style.value;
  if (v === 'Plain') {
    plainFields.forEach(function(el) { el.style.display = ''; });
    revRow.style.display = 'none';
    populateQuiltedPlainPatterns(lineItem);
  } else if (v === 'Reversible') {
    plainFields.forEach(function(el) { el.style.display = 'none'; });
    revRow.style.display = '';
  } else {
    plainFields.forEach(function(el) { el.style.display = 'none'; });
    revRow.style.display = 'none';
  }
}

function bindPatternColour(lineItem, patternSel, colourSel) {
  const pattern = lineItem.querySelector(patternSel);
  const colour = lineItem.querySelector(colourSel);
  if (pattern && colour) {
    pattern.addEventListener('change', function() {
      populateColours(pattern, colour);
      const productId = lineItem.closest('.trade-product-fields').dataset.product;
      updateLineItem(lineItem, productId);
    });
  }
}

function bindLineItem(lineItem) {
  if (lineItem.dataset.bound === 'true') return;
  lineItem.dataset.bound = 'true';

  const productId = lineItem.closest('.trade-product-fields').dataset.product;
  if (!productId) return;

  if (productId === 'quilted-placemats') {
    updateQuiltedStyleRows(lineItem);
    const style = lineItem.querySelector('.line-style');
    if (style) {
      style.addEventListener('change', function() {
        updateQuiltedStyleRows(lineItem);
        updateLineItem(lineItem, productId);
      });
    }
    bindPatternColour(lineItem, '.line-qp-pattern', '.line-qp-colour');
    bindPatternColour(lineItem, '.line-qp-pattern1', '.line-qp-colour1');
    bindPatternColour(lineItem, '.line-qp-pattern2', '.line-qp-colour2');
  } else {
    bindPatternColour(lineItem, '.line-pattern', '.line-colour');
  }

  lineItem.querySelectorAll('.line-style, .line-size, .line-units').forEach(function(el) {
    el.addEventListener('input', function() { updateLineItem(lineItem, productId); });
    el.addEventListener('change', function() { updateLineItem(lineItem, productId); });
  });

  if (FIXED_PRICES[productId] != null) {
    const priceEl = lineItem.querySelector('.line-price');
    if (priceEl) priceEl.dataset.fixedPrice = fmt(FIXED_PRICES[productId]);
  }
  if (productId === 'giftwrapper') {
    const priceEl = lineItem.querySelector('.line-price');
    if (priceEl) priceEl.dataset.fixedPrice = 'TBD';
  }

  updateLineItem(lineItem, productId);
}

function getProductId(lineItem) {
  const fieldsEl = lineItem.closest('.trade-product-fields');
  return fieldsEl ? fieldsEl.dataset.product : null;
}

function resetLineItem(lineItem, productId) {
  lineItem.querySelectorAll('select').forEach(function(el) {
    el.selectedIndex = 0;
    if (el.classList.contains('line-colour') ||
        el.classList.contains('line-qp-colour') ||
        el.classList.contains('line-qp-colour1') ||
        el.classList.contains('line-qp-colour2')) {
      el.innerHTML = '<option value="">Select pattern first</option>';
      el.disabled = true;
    }
  });
  const qpPattern = lineItem.querySelector('.line-qp-pattern');
  if (qpPattern) {
    qpPattern.innerHTML = '<option value="">Select style first</option>';
    qpPattern.disabled = true;
  }
  lineItem.querySelectorAll('input[type="number"]').forEach(function(el) {
    el.value = '';
  });
  const rowTotal = lineItem.querySelector('.row-total-display');
  if (rowTotal) {
    rowTotal.textContent = '—';
    rowTotal.classList.remove('has-value');
  }
  if (!productId) productId = getProductId(lineItem);
  if (!productId) return;
  if (productId === 'quilted-placemats') updateQuiltedStyleRows(lineItem);
  updateLineItem(lineItem, productId);
}

function updateRowLabels(fieldsEl) {
  fieldsEl.querySelectorAll('.trade-line-item').forEach(function(item, index) {
    let label = item.querySelector('.trade-line-item-label');
    if (index === 0) {
      if (label) label.remove();
      return;
    }
    if (!label) {
      label = document.createElement('div');
      label.className = 'trade-line-item-label';
      item.insertBefore(label, item.firstChild);
    }
    label.textContent = 'Line ' + (index + 1);
  });
}

function updateRowActionButtons(fieldsEl) {
  const items = fieldsEl.querySelectorAll('.trade-line-item');
  items.forEach(function(item) {
    const actions = item.querySelector('.trade-field--actions');
    if (!actions) return;
    actions.innerHTML = '';
    if (items.length > 1) {
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'trade-row-btn trade-remove-row-btn';
      removeBtn.setAttribute('aria-label', 'Remove row');
      removeBtn.textContent = '−';
      removeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        removeLineRow(item);
      });
      actions.appendChild(removeBtn);
    }
    const addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'trade-row-btn trade-add-row-btn';
    addBtn.setAttribute('aria-label', 'Add another row');
    addBtn.textContent = '+';
    addBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      addLineRow(item);
    });
    actions.appendChild(addBtn);
  });
  updateRowLabels(fieldsEl);
}

function addLineRow(lineItem, options) {
  options = options || {};
  const fieldsEl = lineItem.closest('.trade-product-fields');
  if (!fieldsEl) return;
  const productId = fieldsEl.dataset.product;
  const container = fieldsEl.querySelector('.trade-line-items');
  const template = container.querySelector('.trade-line-item');
  if (!template) return;
  const clone = template.cloneNode(true);
  clone.removeAttribute('data-bound');
  container.appendChild(clone);
  resetLineItem(clone, productId);
  bindLineItem(clone);
  updateRowActionButtons(fieldsEl);
  if (!options.silent) {
    clone.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

function removeLineRow(lineItem) {
  const fieldsEl = lineItem.closest('.trade-product-fields');
  const items = fieldsEl.querySelectorAll('.trade-line-item');
  if (items.length <= 1) return;
  lineItem.remove();
  updateRowActionButtons(fieldsEl);
  updateProductSubtotal(fieldsEl.dataset.product);
}

function resetProductRows(productId) {
  const fieldsEl = document.getElementById('fields-' + productId);
  if (!fieldsEl) return;
  const container = fieldsEl.querySelector('.trade-line-items');
  const first = container.querySelector('.trade-line-item');
  container.querySelectorAll('.trade-line-item:not(:first-child)').forEach(function(el) { el.remove(); });
  first.removeAttribute('data-bound');
  resetLineItem(first, productId);
  bindLineItem(first);
  updateRowActionButtons(fieldsEl);
  updateRowLabels(fieldsEl);
  setSubtotal(productId, 0);
  updateGrandTotal();
}

function getStorageKey() {
  return STORAGE_KEY;
}

function serializeLineItem(lineItem) {
  const row = {};
  lineItem.querySelectorAll('select, input[type="number"]').forEach(function(el) {
    el.classList.forEach(function(cls) {
      if (cls.indexOf('line-') === 0) row[cls] = el.value;
    });
  });
  return row;
}

function collectFormState() {
  return {
    savedAt: new Date().toISOString(),
    company: {
      company_name: document.getElementById('company_name').value,
      contact_name: document.getElementById('contact_name').value,
      email: document.getElementById('email').value,
      instagram: document.getElementById('instagram').value,
      website: document.getElementById('website').value
    },
    products: Object.keys(PRODUCT_LABELS).reduce(function(acc, productId) {
      const checkbox = document.querySelector('[data-product="' + productId + '"]');
      const fieldsEl = document.getElementById('fields-' + productId);
      if (!checkbox || !fieldsEl) return acc;
      const rows = [];
      fieldsEl.querySelectorAll('.trade-line-item').forEach(function(lineItem) {
        rows.push(serializeLineItem(lineItem));
      });
      acc[productId] = { enabled: checkbox.checked, rows: rows };
      return acc;
    }, {})
  };
}

function applyLineItemData(lineItem, rowData, productId) {
  if (rowData['line-style']) {
    const styleEl = lineItem.querySelector('.line-style');
    if (styleEl) styleEl.value = rowData['line-style'];
    if (productId === 'quilted-placemats') updateQuiltedStyleRows(lineItem);
  }

  PATTERN_COLOUR_PAIRS.forEach(function(pair) {
    const patternCls = pair[0];
    const colourCls = pair[1];
    if (!rowData[patternCls]) return;
    const pattern = lineItem.querySelector('.' + patternCls);
    const colour = lineItem.querySelector('.' + colourCls);
    if (pattern) {
      pattern.value = rowData[patternCls];
      if (colour) populateColours(pattern, colour);
    }
    if (colour && rowData[colourCls]) colour.value = rowData[colourCls];
  });

  if (rowData['line-size']) {
    const sizeEl = lineItem.querySelector('.line-size');
    if (sizeEl) sizeEl.value = rowData['line-size'];
  }
  if (rowData['line-units']) {
    const unitsEl = lineItem.querySelector('.line-units');
    if (unitsEl) unitsEl.value = rowData['line-units'];
  }

  if (productId === 'quilted-placemats') updateQuiltedStyleRows(lineItem);
  updateLineItem(lineItem, productId);
}

function ensureRowCount(fieldsEl, count) {
  const container = fieldsEl.querySelector('.trade-line-items');
  let items = container.querySelectorAll('.trade-line-item');
  while (items.length < count) {
    addLineRow(items[items.length - 1], { silent: true });
    items = container.querySelectorAll('.trade-line-item');
  }
  while (items.length > count && items.length > 1) {
    removeLineRow(items[items.length - 1]);
    items = container.querySelectorAll('.trade-line-item');
  }
}

function loadProductState(productId, productState) {
  const checkbox = document.querySelector('[data-product="' + productId + '"]');
  const fieldsEl = document.getElementById('fields-' + productId);
  if (!checkbox || !fieldsEl || !productState) return;

  if (!productState.enabled) {
    checkbox.checked = false;
    fieldsEl.classList.add('hidden');
    resetProductRows(productId);
    return;
  }

  checkbox.checked = true;
  fieldsEl.classList.remove('hidden');

  const rows = productState.rows && productState.rows.length ? productState.rows : [{}];
  ensureRowCount(fieldsEl, rows.length);

  const items = fieldsEl.querySelectorAll('.trade-line-item');
  rows.forEach(function(rowData, index) {
    if (items[index]) applyLineItemData(items[index], rowData, productId);
  });
  updateProductSubtotal(productId);
}

function formatSavedTime(iso) {
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short'
    });
  } catch (e) {
    return 'recently';
  }
}

function showSavedMessage(savedAt, restored) {
  const el = document.getElementById('form-saved');
  const errorEl = document.getElementById('form-error');
  if (!el) return;
  if (errorEl) errorEl.classList.add('hidden');
  el.textContent = restored
    ? 'Draft restored from ' + formatSavedTime(savedAt) + '. Continue editing or submit when ready.'
    : 'Draft saved at ' + formatSavedTime(savedAt) + '. You can return to this page on the same device to continue.';
  el.classList.remove('hidden');
  el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function saveDraft() {
  const errorEl = document.getElementById('form-error');
  const savedEl = document.getElementById('form-saved');
  if (errorEl) errorEl.classList.add('hidden');

  try {
    const state = collectFormState();
    localStorage.setItem(getStorageKey(), JSON.stringify(state));
    showSavedMessage(state.savedAt, false);
  } catch (err) {
    if (savedEl) savedEl.classList.add('hidden');
    if (errorEl) {
      errorEl.textContent = 'Could not save draft. Check that browser storage is enabled.';
      errorEl.classList.remove('hidden');
    }
  }
}

function loadDraft() {
  try {
    const raw = localStorage.getItem(getStorageKey());
    if (!raw) return;

    const state = JSON.parse(raw);
    if (!state || !state.company) return;

    Object.keys(state.company).forEach(function(key) {
      const el = document.getElementById(key);
      if (el) el.value = state.company[key] || '';
    });

    Object.keys(PRODUCT_LABELS).forEach(function(productId) {
      loadProductState(productId, state.products && state.products[productId]);
    });

    updateGrandTotal();
    showSavedMessage(state.savedAt, true);
  } catch (err) {
    /* ignore corrupt draft */
  }
}

function clearDraft() {
  try {
    localStorage.removeItem(getStorageKey());
  } catch (err) {
    /* ignore */
  }
}

function initTradeOrderForm() {
  initProductRows();

  document.querySelectorAll('.product-enable-check').forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      const product = this.dataset.product;
      const fieldsEl = document.getElementById('fields-' + product);
      if (!fieldsEl) return;
      if (this.checked) {
        fieldsEl.classList.remove('hidden');
      } else {
        fieldsEl.classList.add('hidden');
        resetProductRows(product);
      }
    });
  });

  const saveBtn = document.getElementById('save-draft-btn');
  if (saveBtn) {
    saveBtn.addEventListener('click', saveDraft);
  }

  loadDraft();

  const form = document.getElementById('trade-order-form');
  if (form) {
    form.addEventListener('submit', handleFormSubmit);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTradeOrderForm);
} else {
  initTradeOrderForm();
}

function parseSubtotal(id) {
  const el = document.getElementById('subtotal-' + id);
  if (!el || el.textContent === '—') return 0;
  return parseFloat(el.textContent.replace('$', '').replace(',', '')) || 0;
}

function updateGrandTotal() {
  let total = 0;
  const lines = [];

  Object.keys(PRODUCT_LABELS).forEach(function(id) {
    const checkbox = document.querySelector('[data-product="' + id + '"]');
    if (!checkbox || !checkbox.checked) return;
    const sub = parseSubtotal(id);
    if (sub > 0) {
      total += sub;
      lines.push({ label: PRODUCT_LABELS[id], amount: sub });
    }
  });

  const summarySection = document.getElementById('order-summary-section');
  const summaryLines   = document.getElementById('summary-lines');
  const grandTotalEl   = document.getElementById('grand-total');

  if (total > 0 && summarySection) {
    summarySection.style.display = '';

    summaryLines.innerHTML = lines.map(function(l) {
      return '<div class="trade-summary-line"><span>' + l.label + '</span><span>' + fmt(l.amount) + '</span></div>';
    }).join('');

    grandTotalEl.textContent = fmt(total);
  } else if (summarySection) {
    summarySection.style.display = 'none';
  }
}

function initProductRows() {
  document.querySelectorAll('.trade-product-fields[data-product]').forEach(function(fieldsEl) {
    fieldsEl.querySelectorAll('.trade-line-item').forEach(bindLineItem);
    updateRowActionButtons(fieldsEl);
  });
}

function getOrderApiUrl() {
  const page = document.querySelector('.trade-form-page');
  if (!page) return '';
  const configured = page.dataset.orderApiUrl ? page.dataset.orderApiUrl.trim() : '';
  return configured || '/apps/trade-order/create';
}

function getShopDomain() {
  const page = document.querySelector('.trade-form-page');
  return page && page.dataset.shopDomain ? page.dataset.shopDomain.trim() : '';
}

function buildLineItemTitle(productId, lineItem) {
  const parts = [PRODUCT_LABELS[productId]];

  switch (productId) {
    case 'lampshades':
      parts.push(val(lineItem.querySelector('.line-style')));
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      parts.push(val(lineItem.querySelector('.line-size')) + '"');
      break;
    case 'pouches':
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      break;
    case 'pillow':
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      parts.push(val(lineItem.querySelector('.line-size')));
      break;
    case 'napkins':
      parts.push(val(lineItem.querySelector('.line-style')));
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      break;
    case 'plain-placemats':
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      break;
    case 'quilted-placemats': {
      const style = lineItem.querySelector('.line-style');
      parts.push(val(style));
      if (style && style.value === 'Reversible') {
        parts.push(val(lineItem.querySelector('.line-qp-pattern1')));
        parts.push(val(lineItem.querySelector('.line-qp-colour1')));
        parts.push(val(lineItem.querySelector('.line-qp-pattern2')));
        parts.push(val(lineItem.querySelector('.line-qp-colour2')));
      } else {
        parts.push(val(lineItem.querySelector('.line-qp-pattern')));
        parts.push(val(lineItem.querySelector('.line-qp-colour')));
      }
      break;
    }
    case 'mittens':
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      break;
    case 'tablecloth':
      parts.push(val(lineItem.querySelector('.line-style')));
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      break;
    case 'lampbases':
      parts.push(val(lineItem.querySelector('.line-style')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      parts.push(val(lineItem.querySelector('.line-size')) + '"');
      break;
    case 'giftwrapper':
      parts.push(val(lineItem.querySelector('.line-style')));
      parts.push(val(lineItem.querySelector('.line-pattern')));
      parts.push(val(lineItem.querySelector('.line-colour')));
      break;
  }

  return parts.filter(function(p) { return p && p !== '—' && p !== '"'; }).join(' · ');
}

function buildOrderPayload() {
  const lineItems = [];

  Object.keys(PRODUCT_LABELS).forEach(function(productId) {
    const checkbox = document.querySelector('[data-product="' + productId + '"]');
    if (!checkbox || !checkbox.checked) return;

    const fieldsEl = document.getElementById('fields-' + productId);
    if (!fieldsEl) return;

    fieldsEl.querySelectorAll('.trade-line-item').forEach(function(lineItem, index) {
      const units = getLineUnits(lineItem);
      const unitPrice = getLinePrice(productId, lineItem);
      if (units <= 0 || unitPrice == null) return;

      lineItems.push({
        title: buildLineItemTitle(productId, lineItem),
        quantity: units,
        unitPrice: unitPrice,
        productId: productId,
        lineIndex: index + 1
      });
    });
  });

  const grandTotalEl = document.getElementById('grand-total');
  const estimatedTotal = grandTotalEl && grandTotalEl.textContent !== '$0.00'
    ? parseFloat(grandTotalEl.textContent.replace('$', '').replace(',', '')) || 0
    : 0;

  return {
    shop: getShopDomain(),
    company_name: document.getElementById('company_name').value.trim(),
    contact_name: document.getElementById('contact_name').value.trim(),
    email: document.getElementById('email').value.trim(),
    instagram: document.getElementById('instagram').value.trim(),
    website: document.getElementById('website').value.trim(),
    note: buildOrderNote(),
    estimatedTotal: estimatedTotal,
    lineItems: lineItems
  };
}

async function handleFormSubmit(e) {
  e.preventDefault();

  const errorEl = document.getElementById('form-error');
  const submitBtn = document.getElementById('submit-btn');
  errorEl.classList.add('hidden');

  const required = ['company_name', 'contact_name', 'email'];
  let valid = true;
  required.forEach(function(id) {
    const el = document.getElementById(id);
    if (!el || !el.value.trim()) {
      valid = false;
      if (el) el.style.borderColor = '#c0392b';
    } else {
      if (el) el.style.borderColor = '';
    }
  });

  const anyProduct = Array.from(document.querySelectorAll('.product-enable-check')).some(function(c) { return c.checked; });
  if (!anyProduct) valid = false;

  const payload = buildOrderPayload();
  if (!payload.lineItems.length) valid = false;

  const apiUrl = getOrderApiUrl();
  if (!apiUrl) {
    errorEl.textContent = 'Order API is not configured. Set Order API URL to /apps/trade-order/create in theme settings (requires Shopify app — see shopify-app/README.md).';
    errorEl.classList.remove('hidden');
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  if (!valid) {
    errorEl.textContent = 'Please fill in all required fields, select at least one product, and enter quantities with valid prices.';
    errorEl.classList.remove('hidden');
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  submitBtn.textContent = 'Saving order…';
  submitBtn.disabled = true;

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.error || 'Order creation failed');
    }

    clearDraft();

    if (result.checkoutUrl) {
      submitBtn.textContent = 'Redirecting to checkout…';
      window.location.href = result.checkoutUrl;
      return;
    }

    throw new Error('Checkout link was not returned — please contact support');
  } catch (err) {
    errorEl.textContent = err.message || 'Something went wrong — please try again, save a draft, or contact us directly.';
    errorEl.classList.remove('hidden');
    submitBtn.textContent = 'Continue to checkout';
    submitBtn.disabled = false;
  }
}

function val(el) {
  return el && el.value ? el.value : '—';
}

function buildLineNote(lineItem, productId, index) {
  let block = '';
  const prefix = index > 0 ? '  Line ' + (index + 1) + ':\n' : '  ';

  switch (productId) {
    case 'lampshades':
      block += prefix + 'Style: '   + val(lineItem.querySelector('.line-style')) + '\n';
      block += '  Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      block += '  Size: '    + val(lineItem.querySelector('.line-size')) + '"\n';
      break;
    case 'pouches':
      block += prefix + 'Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      break;
    case 'pillow':
      block += prefix + 'Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      block += '  Size: '    + val(lineItem.querySelector('.line-size')) + '\n';
      break;
    case 'napkins':
      block += prefix + 'Style: '   + val(lineItem.querySelector('.line-style')) + '\n';
      block += '  Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      break;
    case 'plain-placemats':
      block += prefix + 'Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      break;
    case 'quilted-placemats': {
      const style = lineItem.querySelector('.line-style');
      block += prefix + 'Style: ' + val(style) + '\n';
      if (style && style.value === 'Reversible') {
        block += '  Pattern 1: ' + val(lineItem.querySelector('.line-qp-pattern1')) + '\n';
        block += '  Colour 1: '  + val(lineItem.querySelector('.line-qp-colour1')) + '\n';
        block += '  Pattern 2: ' + val(lineItem.querySelector('.line-qp-pattern2')) + '\n';
        block += '  Colour 2: '  + val(lineItem.querySelector('.line-qp-colour2')) + '\n';
      } else {
        block += '  Pattern: ' + val(lineItem.querySelector('.line-qp-pattern')) + '\n';
        block += '  Colour: '  + val(lineItem.querySelector('.line-qp-colour')) + '\n';
      }
      break;
    }
    case 'mittens':
      block += prefix + 'Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      break;
    case 'tablecloth':
      block += prefix + 'Style: '   + val(lineItem.querySelector('.line-style')) + '\n';
      block += '  Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      break;
    case 'lampbases':
      block += prefix + 'Style: '  + val(lineItem.querySelector('.line-style')) + '\n';
      block += '  Colour: ' + val(lineItem.querySelector('.line-colour')) + '\n';
      block += '  Size: '   + val(lineItem.querySelector('.line-size')) + '"\n';
      break;
    case 'giftwrapper':
      block += prefix + 'Style: '   + val(lineItem.querySelector('.line-style')) + '\n';
      block += '  Pattern: ' + val(lineItem.querySelector('.line-pattern')) + '\n';
      block += '  Colour: '  + val(lineItem.querySelector('.line-colour')) + '\n';
      break;
  }

  const units = lineItem.querySelector('.line-units');
  const rowTotal = lineItem.querySelector('.row-total-display');
  block += '  Units: '     + (units && units.value ? units.value : '0') + '\n';
  block += '  Row total: ' + (rowTotal ? rowTotal.textContent : '—') + '\n';
  return block;
}

function buildProductNote(productId, label) {
  const checkbox = document.querySelector('[data-product="' + productId + '"]');
  if (!checkbox || !checkbox.checked) return '';
  const fieldsEl = document.getElementById('fields-' + productId);
  if (!fieldsEl) return '';
  const lines = fieldsEl.querySelectorAll('.trade-line-item');
  let note = '\n' + label.toUpperCase() + '\n';
  lines.forEach(function(lineItem, index) {
    note += buildLineNote(lineItem, productId, index);
    if (index < lines.length - 1) note += '\n';
  });
  note += '  Product subtotal: ' + document.getElementById('subtotal-' + productId).textContent + '\n';
  return note;
}

function buildOrderNote() {
  const company   = document.getElementById('company_name').value;
  const instagram = document.getElementById('instagram').value;
  const website   = document.getElementById('website').value;

  let note = '=== MUSTARD LIVING TRADE SHOW ORDER ===\n\n';
  note += 'Company: ' + company + '\n';
  if (instagram) note += 'Instagram: ' + instagram + '\n';
  if (website)   note += 'Website: ' + website + '\n';
  note += '\n--- PRODUCTS ---';

  Object.keys(PRODUCT_LABELS).forEach(function(id) {
    note += buildProductNote(id, PRODUCT_LABELS[id]);
  });

  note += '\n--- TOTAL ---\n';
  note += 'Estimated total: ' + document.getElementById('grand-total').textContent + '\n';

  return note;
}
